<template>
  <mu-dialog width="760" :open="dialog" :close="close" v-if="welcome_accept">
    <div id="hcpGettingStartedModal">
      <div class="img">
        <img src="static/hcp/hcp_showcase.png" />
      </div>
      <h3>Welcome to the Healthcare Professional Platform</h3>
      <p>Created for clinicians by clinicians to assist you in achieving safe, effective and efficient care for your patients.</p>
      <p>The Low Carb Program provides education and support for people with conditions that can benefit from lifestyle interventions. Condition specific programs are currently available for people with type 2 diabetes, prediabetes or obesity. (Further evidence-based programs are in development)</p>
      <mu-raised-button
        class="btn"
        primary
        label="Get Started"
        fullWidth
        @click="acceptWelcome()"
      />
    </div>
  </mu-dialog>
</template>

<script>

  import HcpMixn from '../../mixins/HCPMixin'
  import HcpApi from '../../api/Hcp';

  export default {
    name: 'hcp-getting-started-modal',
    mixins: [
      HcpMixn
    ],
    data() {
      return {
        dialog: true
      }
    },
    methods: {
      acceptWelcome() {
        let self = this;
        HcpApi.acceptHcpWelcome().then(response => {
          if(response.data.error === false) {
            self.close();
          }
        });
      },
      open() {
        let self = this;
        self.dialog = true;
      },
      close() {
        let self = this;
        self.dialog = false;
      },
    },
    mounted() {

    }
  }

</script>

<style lang="less">
  @import "../../styles/theme.less";
  #hcpGettingStartedModal {
    padding: 20px 40px;
    overflow: auto;
    text-align: center;
    @media only screen and (max-width: 768px) {
      max-height: 500px;
      height: 100%;
      padding: 90px 0;
    }
    h3 {
      font-size: 26px;
      font-weight: 500;
      color: @primaryColor;
    }
    p {
      color: #000000;
    }
    .img {
      text-align: center;
    }
    img {
      width: 100%;
      max-width: 420px;
      height: auto;
    }
    .btn {
      margin: 15px 0 0;
    }
  }
</style>



// WEBPACK FOOTER //
// GettingStartedModal.vue?600bbe82